import Vue from 'vue';
import Router from 'vue-router';

//test
import TestParent from '@/components/test/TestParent.vue';

// landing page
import LandingPage from '@/components/landing/LandingPage.vue';

// auth
import Login from '@/components/auth/Login.vue';
import Oauth2 from '@/components/auth/Oauth2.vue';

// search
import Search from '@/components/search/Search.vue';
import MobileFilters from '@/components/search/MobileFilters.vue';

// dashboard
import Dashboard from '@/components/dashboard/Dashboard.vue';

// list
import ListingStart from '@/components/list/listingStart/ListingStart.vue';
import Category from '@/components/list/category/Category.vue';
import SubCategory from '@/components/list/SubCategory.vue';
import Brand from '@/components/list/Brand.vue';
import Title from '@/components/list/Title.vue';
import AddPhotos from '@/components/list/addPhotos/AddPhotos.vue';
import EditPhoto from '@/components/list/EditPhoto.vue';
import Description from '@/components/list/Description.vue';
import Tags from '@/components/list/tags/Tags.vue';
import PickupAddress from '@/components/list/PickupAddress.vue';
import DeliveryOptions from '@/components/list/deliveryOptions/DeliveryOptions.vue';
import Rates from '@/components/list/rates/Rates.vue';
import Deposit from '@/components/list/Deposit.vue';
import ListSignup from '@/components/list/ListSignup.vue';
import AdditionalFees from '@/components/list/additionalFees/AdditionalFees.vue';

// edit list
import EditListingMenu from '@/components/editListing/editListingMenu/EditListingMenu.vue';

// rent
import ListingDetail from '@/components/rent/listingDetail/ListingDetail.vue';
import RentalDetails from '@/components/rent/rentalDetails/RentalDetails.vue';
import Payment from '@/components/rent/payment/Payment.vue';
import PaymentConfirm from '@/components/rent/PaymentConfirm.vue';

// my rentals & listings
import MobileMenus from '@/components/rentalsListings/menus/MobileMenus.vue';
import RentalsHistoryList from '@/components/rentalsListings/rentalHistory/RentalsHistoryList.vue';
import RentalHistory from '@/components/rentalsListings/rentalHistory/RentalHistory.vue';
import InvoicesList from '@/components/rentalsListings/invoices/InvoicesList.vue';
import InvoiceDetail from '@/components/rentalsListings/invoices/InvoiceDetail.vue';
import ActiveListingsList from '@/components/rentalsListings/activeListings/activeListingsList/ActiveListingsList.vue';
import DeactivatedListingsList from '@/components/rentalsListings/activeListings/DeactivatedListingsList.vue';
import DeactivatedListing from '@/components/rentalsListings/activeListings/DeactivatedListing.vue';
import ActiveListing from '@/components/rentalsListings/activeListings/ActiveListing.vue';
import UpcomingRental from '@/components/rentalsListings/upcomingRentals/upcomingRental/UpcomingRental.vue';
import UpcomingRentalsList from '@/components/rentalsListings/upcomingRentals/UpcomingRentalsList.vue';

// account settings
import SettingsMobile from '@/components/accountSettings/SettingsMobile.vue';
import AccountInfoCard from '@/components/accountSettings/AccountInfoCard.vue';
import NotificationsCard from '@/components/accountSettings/notificationsCard/NotificationsCard.vue';
import PasswordReset from '@/components/accountSettings/PasswordReset.vue';

// inbox
import Inbox from '@/components/inbox/Inbox.vue';
import MessagesMobile from '@/components/inbox/MessagesMobile.vue';

// misc
import ErrorPage from '@/components/misc/ErrorPage.vue';

Vue.use(Router);

var router = new Router({
    mode: 'history',
    routes: [
        //test
        {
            path: '/test',
            component: TestParent
        },
        // landing page
        {
            path: '/',
            component: LandingPage
        },
        {
            path: '/login',
            component: Login
        },
        {
            path: '/login/:type',
            component: Oauth2
        },
        // search
        {
            path: '/search',
            component: Search
        },
        {
            path: '/mobile-filters',
            component: MobileFilters
        },
        // dashboard
        {
            path: '/dashboard',
            component: Dashboard,
            meta: { auth: true }
        },
        // list
        {
            path: '/listing-start',
            component: ListingStart
        },
        {
            path: '/category',
            component: Category,
            meta: { auth: true }
        },
        {
            path: '/sub-category',
            component: SubCategory,
            meta: { auth: true }
        },
        {
            path: '/brand',
            component: Brand,
            meta: { auth: true }
        },
        {
            path: '/title',
            component: Title,
            meta: { auth: true }
        },
        {
            path: '/add-photos',
            component: AddPhotos,
            meta: { auth: true }
        },
        {
            path: '/edit-photo/:index',
            component: EditPhoto,
            meta: { auth: true }
        },
        {
            path: '/description',
            component: Description,
            meta: { auth: true }
        },
        {
            path: '/tags',
            component: Tags,
            meta: { auth: true }
        },
        {
            path: '/pickup-address',
            component: PickupAddress,
            meta: { auth: true }
        },
        {
            path: '/owner-delivery',
            component: DeliveryOptions,
            meta: { auth: true }
        },
        {
            path: '/rates',
            component: Rates,
            meta: { auth: true }
        },
        {
            path: '/deposit',
            component: Deposit,
            meta: { auth: true }
        },
        {
            path: '/list-signup',
            component: ListSignup
        },
        {
            path: '/additional-fees',
            component: AdditionalFees,
            meta: { auth: true }
        },
        // edit list
        {
            path: '/edit-listing-menu/:id',
            component: EditListingMenu,
            meta: { auth: true }
        },
        // rent
        {
            path: '/listing-detail/:id',
            component: ListingDetail
        },
        {
            path: '/rental-details/:id',
            component: RentalDetails
        },
        {
            path: '/payment',
            component: Payment,
            meta: { auth: true }
        },
        {
            path: '/payment-confirm',
            component: PaymentConfirm,
            meta: { auth: true }
        },
        // my rentals & listings
        {
            path: '/rentals-listings-mobile',
            component: MobileMenus,
            meta: { auth: true }
        },
        {
            path: '/rentals-history',
            component: RentalsHistoryList,
            meta: { auth: true }
        },
        {
            path: '/rental-history/:id',
            component: RentalHistory,
            meta: { auth: true }
        },
        {
            path: '/invoices',
            component: InvoicesList,
            meta: { auth: true }
        },
        {
            path: '/invoice-detail/:id',
            component: InvoiceDetail,
            meta: { auth: true }
        },
        {
            path: '/active-listings',
            component: ActiveListingsList,
            meta: { auth: true }
        },
        {
            path: '/active-listing/:id',
            component: ActiveListing,
            meta: { auth: true }
        },
        {
            path: '/upcoming-rental/:id',
            component: UpcomingRental,
            meta: { auth: true }
        },
        {
            path: '/upcoming-rentals',
            component: UpcomingRentalsList,
            meta: { auth: true }
        },
        {
            path: '/deactive-listings',
            component: DeactivatedListingsList,
            meta: { auth: true }
        },
        {
            path: '/deactive-listing/:id',
            component: DeactivatedListing,
            meta: { auth: true }
        },
        // account settings
        {
            path: '/settings-mobile',
            component: SettingsMobile,
            meta: { auth: true }
        },
        {
            path: '/account-info',
            component: AccountInfoCard,
            meta: { auth: true }
        },
        {
            path: '/notifications',
            component: NotificationsCard,
            meta: { auth: true }
        },
        {
            path: '/password-reset/:token',
            component: PasswordReset
        },
        // inbox
        {
            path: '/inbox',
            component: Inbox,
            meta: { auth: true }
        },
        {
            path: '/messages-mobile',
            component: MessagesMobile,
            meta: { auth: true }
        },
        // misc
        {
            path: '/error-page',
            component: ErrorPage
        }
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

export default router;
